import type { TFunction } from 'i18next'

import guaranteedScheduleEn from '@src/assets/images/resources-menu/guaranteed-schedule-en.webp'
import guaranteedScheduleFr from '@src/assets/images/resources-menu/guaranteed-schedule-fr.webp'
import leadershipEn from '@src/assets/images/resources-menu/leadership-en.webp'
import leadershipFr from '@src/assets/images/resources-menu/leadership-fr.webp'
import powerBiEn from '@src/assets/images/resources-menu/powerbi-en.webp'
import powerBiFr from '@src/assets/images/resources-menu/powerbi-fr.webp'
import projectManagementEn from '@src/assets/images/resources-menu/project-management-en.webp'
import projectManagementFr from '@src/assets/images/resources-menu/project-management-fr.webp'
import trainingCatalogEn from '@src/assets/images/resources-menu/training-catalog-en.webp'
import trainingCatalogFr from '@src/assets/images/resources-menu/training-catalog-fr.webp'
import locales from '@src/config/locales'

export function getResourcesLinks(t: TFunction, locale: string) {
  return [
    { title: t('blog'), link: locales[locale].blogPath },
    { title: t('fundingPrograms'), link: locales[locale].fundingPath },
    { title: t('newsletter'), link: locales[locale].newsletterPath },
    { title: t('faq'), link: locales[locale].faqPath },
    { title: t('contact'), link: t('contactUrl') },
  ]
}

export function getResourcesTabs(t: TFunction, locale: string) {
  return [
    {
      title: t('resourcesTab.projectManagement.title'),
      section: {
        title: t('resourcesTab.projectManagement.sectionTitle'),
        image: locale === 'en' ? projectManagementEn : projectManagementFr,
        description: t('resourcesTab.projectManagement.sectionDescription'),
        link: t('resourcesTab.projectManagement.link'),
      },
    },
    {
      title: t('resourcesTab.leadership.title'),
      section: {
        title: t('resourcesTab.leadership.sectionTitle'),
        image: locale === 'en' ? leadershipEn : leadershipFr,
        description: t('resourcesTab.leadership.sectionDescription'),
        link: t('resourcesTab.leadership.link'),
      },
    },
    {
      title: t('resourcesTab.trainingCatalog.title'),
      section: {
        title: t('resourcesTab.trainingCatalog.sectionTitle'),
        image: locale === 'en' ? trainingCatalogEn : trainingCatalogFr,
        description: t('resourcesTab.trainingCatalog.sectionDescription'),
        link: t('resourcesTab.trainingCatalog.link'),
      },
    },
    {
      title: t('resourcesTab.guaranteedSessions.title'),
      section: {
        title: t('resourcesTab.guaranteedSessions.sectionTitle'),
        image: locale === 'en' ? guaranteedScheduleEn : guaranteedScheduleFr,
        description: t('resourcesTab.guaranteedSessions.sectionDescription'),
        link: t('resourcesTab.guaranteedSessions.link'),
      },
    },
    {
      title: t('resourcesTab.powerBi.title'),
      section: {
        title: t('resourcesTab.powerBi.sectionTitle'),
        image: locale === 'en' ? powerBiEn : powerBiFr,
        description: t('resourcesTab.powerBi.sectionDescription'),
        link: t('resourcesTab.powerBi.link'),
      },
    },
  ]
}
